import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPencilAi: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPencilAi"><Path d="M16.5 4.5L5 16L4 22L10 21L21.5 9.5C22.8807 8.11929 22.8807 5.88071 21.5 4.5C20.1193 3.11929 17.8807 3.11929 16.5 4.5Z" stroke="currentColor" strokeLinecap="round"/><Path d="M15.5 6L20 10.5" stroke="currentColor"/><Path d="M6.35 2.5H5.65L4.775 4.775L2.5 5.65V6.35L4.775 7.225L5.65 9.5H6.35L7.225 7.225L9.5 6.35V5.65L7.225 4.775L6.35 2.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconPencilAi;
